import type { OnboardingIntent } from './onboardingIntent';

/** The stops of the LaziiBee tour, in the default order (spec §4.3). `home` is always last. */
export const TOUR_STOPS = ['kit', 'plan', 'link', 'numbers', 'home'] as const;

export type TourStop = (typeof TOUR_STOPS)[number];

const FIRST_STOP: Record<OnboardingIntent, TourStop> = {
  promote: 'plan',
  analytics: 'numbers',
  publicData: 'numbers',
  teams: 'kit',
};

/** The stops for an intent: the intent's stop first, the others in order, `home` last. */
export function tourStops(intent: OnboardingIntent | null): TourStop[] {
  const middle = TOUR_STOPS.filter((stop) => stop !== 'home');
  const first = intent === null ? 'kit' : FIRST_STOP[intent];
  const start = middle.indexOf(first as (typeof middle)[number]);
  return [...middle.slice(start), ...middle.slice(0, start), 'home'];
}
